import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconRinging: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0001 20.2482C8.46372 20.2482 5.90275 19.508 5.65527 16.5349C5.65527 13.5653 7.44093 13.7549 7.44093 10.1098C7.44093 7.26164 10.0291 4.02295 14.0001 4.02295C17.9709 4.02295 20.5592 7.26164 20.5592 10.1087C20.5592 13.7537 22.3448 13.5631 22.3448 16.5349C22.0961 19.5182 19.5352 20.2482 14.0001 20.2482Z"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.647 23.3335C12.2202 24.0498 13.0807 24.5005 14.032 24.5005C14.9946 24.5005 15.855 24.0498 16.4283 23.3335"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08236 3.50928C5.9767 4.5843 5.16731 5.88522 4.71777 7.23609"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2801 7.24724C22.8295 5.89524 22.0212 4.58523 20.9053 3.5"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconRinging;
